import React from "react";
import {connect} from "react-redux";
import {CheckboxTable} from "../../view/CheckboxTable";
import {debug} from "../../utils";
import InventoryScanTableRow from "./InventoryScanTableRow";
import { useInventoryTableHelper } from "./useInventoryTableHelper";


function InventoryScanTable({inventoryList}) {

    const inventoryTableHelper = useInventoryTableHelper();

    //Table Headers
    const headers = [
        {name: 'HOST', sortKey: 'host', onClick: () => inventoryTableHelper.onHostClick()},
        {name: 'STATUS', sortKey: 'status', onClick: () => inventoryTableHelper.onStatusClick()},
        {name: 'OS', sortKey: 'os', onClick: () => inventoryTableHelper.onOSClick()},
        {name: 'DATE', onClick: () => {}},
        {name: 'OPEN PORTS'},

    ]

    return (
        <>
            {inventoryList.length > 0 ?
            <CheckboxTable headers={headers} elements={inventoryList}>
                {inventoryList.map((inventory, index) => <InventoryScanTableRow key={index} data={inventory} index={index}/>)}
            </CheckboxTable>
            :
            <div className="network-scan-empty-v2">No network inventory found</div>}
        </>
    )

}


function mapStateToProps(state) {
    debug("InventoryScanTable mapStateToProps", state);
    const inventoryPage = state.inventoryPage;
    return {
        inventoryList: inventoryPage.inventoryList || []
    };
}


export default connect(mapStateToProps)(InventoryScanTable);
